<a *ngIf="fullLocation" href="{{ url }}" target="_blank">{{ fullLocation }}</a>
